import { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { AuthShell } from "@/pages/Login";
import { MailCheck } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      // Endpoint never reveals existence — still show the same confirmation on error
      setSent(true);
    } finally {
      setLoading(false);
    }
  };

  if (sent) {
    return (
      <AuthShell title="Check Your Email" sub="Reset link on its way.">
        <div className="space-y-6" data-testid="forgot-sent">
          <div className="flex items-start gap-3 border border-[#FFB800]/30 bg-[#FFB800]/[0.06] p-5 rounded">
            <MailCheck className="w-6 h-6 text-[#FFB800] shrink-0 mt-0.5" />
            <p className="font-body text-white/90 text-sm leading-relaxed">
              If an account exists for <span className="font-700">{email}</span>, we&apos;ve sent a password reset link.
              It expires in 1 hour. Check your inbox (and spam folder).
            </p>
          </div>
          <Link to="/login" className="btn-signal w-full h-14 font-head text-lg flex items-center justify-center" data-testid="back-to-login">
            Back to Log In
          </Link>
        </div>
      </AuthShell>
    );
  }

  return (
    <AuthShell title="Forgot Password" sub="We'll email you a reset link.">
      <form onSubmit={submit} className="space-y-5" data-testid="forgot-form">
        <div>
          <label className="il-label">Email</label>
          <input
            className="il-input" type="email" value={email}
            onChange={(e) => setEmail(e.target.value)} required
            data-testid="forgot-email" placeholder="you@fleet.com"
          />
        </div>
        <button className="btn-signal w-full h-14 font-head text-lg" disabled={loading} data-testid="forgot-submit">
          {loading ? "Sending…" : "Send Reset Link"}
        </button>
      </form>
      <p className="font-body text-[#94A3B8] mt-6 text-sm">
        Remembered it? <Link to="/login" className="text-[#FFB800] font-700" data-testid="goto-login">Back to Log In →</Link>
      </p>
    </AuthShell>
  );
}
